export default __webpack_public_path__ + "static/CentraNo2-Medium-3c5d88e60d773c0fd8e662e58e9861f7.woff";